enum LoadingEvent {
  SHOW = 'show-builder-bonus-loading',
  HIDE = 'hide-builder-bonus-loading',
}

export default LoadingEvent;
